import React, { Component } from 'react';
import ProjectsLayout from '../../templates/project';
import _ from "lodash";
import InstanceEditForm from '../../elements/project/instance';
import Loading from "../../elements/loading";

class ProjectAgency extends Component {
	render (){
		let {entities, municipalities, modalities,match, revision, project} = this.props;
		return (
			project.instance.isFetching ? <Loading message="Cargando..."/>:
			<InstanceEditForm
					fetching={project.instance.isFetching}
					owner={project.owner.data}
					instance={project.instance}
					entities={entities}
					municipalities={municipalities}
					modalities={modalities}
					match={match}
					revision={revision.instance}
					permissions={project.permissions}
					saveAgency={this.props.saveAgency}
					projectAgencyExport={this.props.projectAgencyExport}
					fetchMunicipalities={this.props.fetchMunicipalities}
					setSystemNotification={this.props.setSystemNotification}
					change={this.props.change}
					history={this.props.history}
					disabled={this.blockFields()}
				/>
		);
	}

	constructor() {
		super();
		this.blockFields = this.blockFields.bind(this);
	}

	componentWillMount() {
		let { modality, state, municipality } = this.props.match.params;
		this.props.fetchAgency(modality, state, municipality);
	}

	componentWillReceiveProps(newprops) {
		let { modality, state, municipality } = newprops.match.params;
		if(this.props.location.pathname !== newprops.location.pathname) {
			this.props.fetchAgency(modality, state, municipality);
		}
	}

	blockFields() {
		let { instance } = this.props.project;
		let response = false;
		let editable = instance.editable;
		let instanceRevision = !_.isEmpty(instance.revision) ? instance.revision.body : undefined;

		if(!_.isEmpty(instanceRevision) && !instance.isFetching){
			let allow = _.find(instanceRevision, {allow_edit: 'true'}) ? true : false;
			if(editable && allow){
				response = false;
			}else{
				response = true;
			}
		}else if(editable && !instance.isFetching){
			response = false;
		}else {
			response = true;
		}

		return response;
	}

}

export default ProjectsLayout(ProjectAgency, {subnav: 2});



// WEBPACK FOOTER //
// ./src/layouts/project/instance.jsx